import { Flex, FlexProps, Icon, Switch, Text } from "@chakra-ui/react";
import { useEffect } from "react";
import { AiOutlineInfoCircle } from "react-icons/ai";
import { Tooltip } from "barte-design-system";
type LengthUnit = "px" | "em" | "rem" | "vw" | "vh" | "%";
type Size = `${number}${LengthUnit}`;

interface TimerSwitchProps extends FlexProps {
  text: string;
  switchSize?: "sm" | "md" | "lg";
  tooltipText?: string;
  tooltipTextSwitch?: string;
  fontSize?: Size;
  color?: `#${number}` | string;
  timerState: boolean;
  setTimerState: (value: boolean) => void;
  expirationDate: boolean;
}

export function TimerSwitch({
  timerState,
  setTimerState,
  tooltipText,
  text,
  color = "black",
  fontSize = ".8rem",
  switchSize = "sm",
  tooltipTextSwitch,
  expirationDate,
  ...rest
}: TimerSwitchProps) {
  function handleSwitchChange() {
    setTimerState(!timerState);
  }
  function verifyExpirationDate() {
    if(!expirationDate) setTimerState(false);
  }
  useEffect(() => {
    verifyExpirationDate();
  }, [expirationDate]);
  return (
    <Flex {...rest} >
      <Tooltip placement="top"  label={tooltipTextSwitch}>
        <span>
          <Switch
            disabled={!expirationDate}
            size={switchSize}
            colorScheme="cyan"
            isChecked={expirationDate && timerState}
            onChange={handleSwitchChange}
          />
        </span>
      </Tooltip>
      <Flex align="center">
        <Text fontSize={fontSize} color={color} marginRight={tooltipText ? ".2rem" : ""}>
          {text}
        </Text>
        {tooltipText && (
          <Tooltip placement="top"  label={tooltipText}>
            <span>
              <Icon w=".8rem" color="gray.400" as={AiOutlineInfoCircle} />
            </span>
          </Tooltip>
        )}
      </Flex>
    </Flex>
  );
}